import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "k-dialog-wrapper",
  tabindex: "0"
}
const _hoisted_3 = {
  class: "k-widget k-window k-dialog",
  role: "dialog"
}
const _hoisted_4 = { class: "k-window-titlebar k-dialog-titlebar" }
const _hoisted_5 = { class: "k-window-title k-dialog-title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "k-window-actions k-dialog-actions" }
const _hoisted_8 = { class: "m-container" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "k-content k-window-content k-dialog-content" }
const _hoisted_11 = { class: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.errorDialogParameter.isErrorDialog)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  innerHTML: _ctx.errorDialogParameter.title
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "k-button k-button-md k-rounded-md k-icon-button k-button-flat k-button-flat-base k-window-action k-dialog-action",
                  "aria-label": "Close",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.applyOk()), ["prevent"]))
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("span", {
                    role: "presentation",
                    class: "k-icon k-button-icon k-i-x"
                  }, null, -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                innerHTML: _ctx.errorDialogParameter.text,
                class: "m-content"
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", _hoisted_11, [
                _createElementVNode("span", {
                  class: "k-button-text",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.applyOk()), ["prevent"]))
                }, "Schliessen")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}